import { useState } from "react";
import {
  Hydrate,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import NProgress from "nprogress";
import Router from "next/router";

import Theme from "../themes";

import "../themes/ant.css";
import GlobalStyle from "../styles/global.style";
import "nprogress/nprogress.css";
// import "@module-federation/nextjs-mf/src/include-defaults";

NProgress.configure({
  minimum: 0.3,
  easing: "ease",
  speed: 800,
  showSpinner: false,
});

Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

if (process.env.NODE_ENV === "development") {
  require("react/jsx-dev-runtime");
}

const MyApp = ({ Component, pageProps }: any) => {
  const { dehydratedState, isMobile, theme } = pageProps;

  const [queryClient] = useState(() => new QueryClient());
  // const [profile, setProfile] = useState();

  // const setInitialData = useCallback(async () => {
  //   const profilePromise = (await queryClient.fetchQuery(
  //     ["profile"],
  //     GetProfileAxios
  //   )) as any;
  //   setProfile(profilePromise);
  // }, [queryClient]);

  // useEffect(() => {
  //   if (!profile) setInitialData();
  // }, [profile, setInitialData]);

  return (
    <QueryClientProvider client={queryClient}>
      <Theme isMobile={isMobile} serverTheme={theme}>
        <GlobalStyle />
        <Hydrate state={dehydratedState}>
          <Component {...{ ...pageProps, isMobile }} />
        </Hydrate>
        <ReactQueryDevtools initialIsOpen={false} />
      </Theme>
    </QueryClientProvider>
  );
};

export default MyApp;
